import React, { useState, useEffect } from 'react';
import { Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getTemplate } from '../store/actions/CommonAction';
import { Typography } from '@material-ui/core';
import Search from '@mui/icons-material/Search';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { ToastContainer, toast } from 'react-toastify';

let templateList = [];
const ManageTemplate = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [item, setItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { from } = useParams();
 // const [templateList, setTemplateList] = useState([]);
  
 
  const dashboarddata = useSelector((state) => state.common.dashboarddata);

  //const getTemplateList = useSelector(state => state.common.getTemplateList);
 // alert("getTemplateList : "+JSON.stringify(getTemplateList));
  const clientId = useSelector(state => state.common.clientId);

  const receivedConsentGroup = useSelector(state => state.common.receivedConsentGroup);

  const handleClose = () => setShow(false);
  const handleShow = (template) => {

    console.log("handleShow : "+JSON.stringify(template));
    setItem(template);
    setShow(true);
  };

  const fetchTemplates = async (key, param) => {
   // await dispatch(getTemplate(key, param));

   //alert("dashboarddata : "+JSON.stringify(dashboarddata.templateDetails));

    if(key == "clientId"){
      templateList = dashboarddata.templateDetails;
      console.log("templateList : "+JSON.stringify(templateList));
    }else if(key == "consentGroupId"){
      const consentGroupDetails = dashboarddata.templateDetails.filter((item) => item.consentGroupId == param);
      console.log("consentGroupDetails : "+JSON.stringify(consentGroupDetails));
      templateList = consentGroupDetails;
      console.log("templateList in consentGroupId : "+JSON.stringify(templateList));
    }

    setIsLoading(false);
  };

  const formatDate = (isoDateString) => {
    // Create a Date object from the ISO string
    const date = new Date(isoDateString);
  
    // Extract day, month, and year
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getUTCFullYear();
  
    // Format the date as dd/mm/yyyy
    return `${day}/${month}/${year}`;
  };


  useEffect(() => {

    

    if(from == "fromDashboard"){
      if(receivedConsentGroup != undefined){
        fetchTemplates("consentGroupId",receivedConsentGroup.consentGroupId);
      }
    }else{
      fetchTemplates("clientId",clientId);
    }


   



  }, [dispatch, clientId, from, receivedConsentGroup, dashboarddata]);

  useEffect(() => {
    if(!sessionStorage.getItem('sessionId')){
      toast.error(`Your Session has Expired: Please login again`);
      window.location.href = '/login';
  }
    // Add body class when component mounts
    document.body.classList.add('manage');
    // Remove body class when component unmounts
    return () => {
      document.body.classList.remove('manage');
    };
  }, []);

  return (
    <>
      {/* <section className='content-header'>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-5'>
              <h1 className='page-title'>
                Manage Template
                <span>We will help you to manage templates.</span>
              </h1>
            </div>
            <div className='col-md-7'>
              <div className='row'>
                <div className='col-md-6 offset-md-2 my-3 my-md-0'>
                  <FormControl fullWidth variant="standard">
                    <InputLabel>Search by consent group, template</InputLabel>
                    <Input
                      type='password'
                      size='small'
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                          >
                            <Search />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <section className='content h-100'>
        <div className='container' style={{marginTop:'10%',marginBottom:'2%'}}>
          <div className='row'>
            <div className='col-md-12'>
              <div class="card custom-cards">
                <div class="card-body">
                  <div className='row align-items-center mt-3 mb-4'>
                    <div className='col-md-12'>
                      {from && from == "fromDashboard" && receivedConsentGroup &&
                        <h4 className='m-0'>Consent Group Name : {receivedConsentGroup.consentGroupName}</h4>
                      }
                    </div>
                  </div>
                  <div className="card dashboard-card">
                    <div className="card-body">
                      <div className="text-center">
                        <table className="table dashboard-table">
                          <thead>
                            <tr>
                              {/* <th scope="col">S.No</th> */}
                              <th scope="col">Template name</th>
                              <th scope="col">Date</th>
                              <th scope="col">Total Consents</th>
                              <th scope="col">Active</th>
                              <th scope="col">Revoked</th>
                              <th scope="col">Rejected</th>
                              <th scope="col">Expired</th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading ? (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </td>
                              </tr>
                            ) : templateList && templateList.length === 0 ? (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  {templateList.length}
                                  <Typography align="center" style={{ fontSize: 20 }}>No templates available.</Typography>
                                </td>
                              </tr>
                            ) : (
                              templateList && templateList.map((consentGroup, index) => (

                                consentGroup.templateDetails && consentGroup.templateDetails.map((template, index) => (
                                 <tr key={`${index}`}>
                                    {/* <td>{index + 1 < 10 ? `0${index + 1}` : index + 1}</td> */}
                                   
                                    <td className="link-primary" onClick={() => handleShow(template)} style={{cursor:'pointer'}}>{template.nickName}</td>
                                    <td>{formatDate(template.createdTimestamp)}</td>
                                    <td>{template.consentDetails.total}</td>
                                    <td>{template.consentDetails.active}</td>
                                    <td>{template.consentDetails.revoked}</td>
                                    <td>{template.consentDetails.rejected}</td>
                                    <td>{template.consentDetails.expired}</td>
                                  </tr>

                              ))
                           )) )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div className='row mt-2 justify-content-between'>
                    {/* Pagination and info */}
                    {/* <div className='col-md-auto me-auto '>
                      <div className='dt-info'>
                          {getTemplateList &&
                              getTemplateList.length > 0 ? (
                                <div className="dt-info">
                                  Showing 1 to {getTemplateList.length} entries of {getTemplateList.length} entries
                                </div>
                              ) : (
                                <div>
                                  {getTemplateList && getTemplateList 
                                    ? `${getTemplateList.length} entries present`
                                    : "No entries present"}
                                </div>
                              )}
                      </div>
                  </div> */}
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {item &&
        <Modal show={show} size='xl' onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>Template : {item.nickName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="table-responsive">
                <table className="table dashboard-table popupTable">
                                <thead>
                                  <tr>
                                    {/* <th scope="col">Consent Group Name</th> */}
                                    <th scope="col">DataSet Name</th>
                                    <th scope="col">Mandatory</th>
                                    <th scope="col">Data Used By</th>
                                    <th scope="col">Data Type</th>
                                    <th scope="col">Data Item</th>
                                    <th scope="col">Purpose</th>
                                    <th scope="col">Validity</th>
                                  </tr>
                                </thead>
                                <tbody>
                                      <tr>
                                          {/* <td>{item.consentGroupName}</td> */}
                                          <td>{item.nickName}</td>
                                          <td>{item.mandatory !== undefined ? item.mandatory.toString() : 'N/A'}</td>
                                          <td>
                                            {(item.dataConsumer || []).map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.dataConsumer.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                          </td>
                                          <td>
                                            {(item.consentTypes || []).map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.consentTypes.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                          </td>
                                          <td style={{width:'20%'}}>
                                            {(item.dataTypes || []).map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.dataTypes.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                          </td>
                                          <td>
                                            {(item.purpose || []).map((ele, key) => (
                                              <React.Fragment key={key}>{ele}{key === item.purpose.length - 1 ? '' : ', '}</React.Fragment>
                                            ))}
                                            </td>
                                          <td>{item.consentValidity.value}&nbsp;{item.consentValidity.unit}</td>
                                        </tr>
                                    
                                </tbody>
                              </table>
              
                              </div>

            {/* <h6>Consent Group Name: {item.consentGroupName}</h6>
            <table align="center" className="table table-borderless table-sm">
              <tbody>
               <tr>
                  <td>Consent Group Name: </td>
                  <td>{item.consentGroupName}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>{template.nickName}</td>
                </tr>
                <tr>
                  <td>Data Consumer</td>
                  <td>{template.dataConsumer}</td>
                </tr>
                <tr>
                  <td>Data Provider</td>
                  <td>{template.dataProvider}</td>
                </tr>
                <tr>
                  <td>Purpose</td>
                  <td>{template.purpose}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td className={item.status === "ACTIVE" ? "text-success" : "text-danger"}>{item.status}</td>
                </tr>
                
              </tbody>
            </table> */}
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-outline-secondary btn-sm" onClick={handleClose}>Close</button>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
};

export default ManageTemplate;
